(function() {
    function context(suffix) {
        var s = (typeof suffix === 'string') ? suffix : '';
        return {
            suffix: s,
            selected: 'varSelectedProperties' + s,
            colorName: 'varSelectedColorName' + s,
            fallbackParts: 'varColorFallbackParts' + s,
            product: 'srvGetProduct' + s
        };
    }

    function getComponent(id) {
        if (typeof dmx === 'undefined' || !dmx.app) return null;
        if (dmx.app[id]) return dmx.app[id];
        if (typeof dmx.app.$component === 'function') {
            var c = dmx.app.$component(id);
            if (c) return c;
        }
        var node = document.getElementById(id);
        if (node && node.dmxComponent) return node.dmxComponent;
        return null;
    }

    // Serverconnects may live under a view scope (e.g. dmx.app.data.view1.srvGetProduct),
    // not at dmx.app top level — walk scopes to find the named one.
    function getProductData(id) {
        if (typeof dmx === 'undefined' || !dmx.app) return null;
        if (dmx.app[id] && dmx.app[id].data) return dmx.app[id].data;
        var scopes = dmx.app.data;
        if (scopes) {
            for (var key in scopes) {
                var v = scopes[key];
                if (v && v[id] && v[id].data) return v[id].data;
            }
        }
        return null;
    }

    function getNotifyComponent() {
        return getComponent('notifies1');
    }

    function rewriteSelections(c, newItems) {
        // Private _updateData fires one reactive notify; public empty()+concat() doubles re-renders.
        if (typeof c._updateData === 'function') {
            c._updateData(newItems);
        } else if (c.methods) {
            c.methods.empty.call(c);
            c.methods.concat.call(c, newItems);
        }
    }

    function setValue(id, value) {
        var comp = getComponent(id);
        if (comp && comp.methods && typeof comp.methods.setValue === 'function') {
            comp.methods.setValue.call(comp, value);
        }
    }

    function parseCsv(s) {
        return (s == null || s === '') ? [] : String(s).split(',');
    }

    function truthy(v) { return v === true || v === 1 || v === '1'; }

    function makeSelection(parentId, propertyId, propertyPrice) {
        return {
            property_parent_id: Number(parentId),
            property_id: Number(propertyId),
            property_price: Number(propertyPrice) || 0
        };
    }

    window.setProductProperty = function(parentId, propertyId, propertyPrice, suffix) {
        var ctx = context(suffix);
        var c = getComponent(ctx.selected);
        if (!c) { console.warn('[property-selector] ' + ctx.selected + ' not found'); return; }
        var pid = Number(parentId);
        var current = (c.data && c.data.items) ? c.data.items.slice() : [];
        var filtered = current.filter(function(it) { return Number(it.property_parent_id) !== pid; });
        if (propertyId !== '' && propertyId != null) {
            filtered.push(makeSelection(pid, propertyId, propertyPrice));
        }
        rewriteSelections(c, filtered);
    };

    function allColorGroupIds(productData) {
        var ids = {};
        var opts = productData && productData.productColorOptions;
        if (opts) {
            for (var i = 0; i < opts.length; i++) {
                parseCsv(opts[i].color_group_ids).forEach(function(id) { ids[Number(id)] = true; });
            }
        }
        return ids;
    }

    // Single pass over productProperties: per group capture business default
    // (property_default=1, first row as fallback) plus the Silver option —
    // Black-only gaps (nut secondary, rollers) ship silver on the real product.
    function buildGroupFallbacks(productData) {
        var byGroup = {};
        var props = productData && productData.productProperties;
        if (!props) return byGroup;
        for (var i = 0; i < props.length; i++) {
            var p = props[i];
            if (!truthy(p.is_color_option)) continue;
            var gid = Number(p.property_parent_id);
            var entry = byGroup[gid] || (byGroup[gid] = {});
            var row = {
                selection: makeSelection(gid, p.property_id, p.property_price),
                parentName: p.property_parent_name,
                colorName: p.property_name
            };
            if (p.property_name === 'Silver') entry.silver = row;
            if (truthy(p.property_default) && !entry.locked) { entry.def = row; entry.locked = true; }
            else if (!entry.def) entry.def = row;
        }
        return byGroup;
    }

    function notifyFallbacks(colorName, fallbacks) {
        if (!fallbacks.length) return;
        var notif = getNotifyComponent();
        if (!notif) return;
        var parts = fallbacks.map(function(f) { return f.parentName + ' uses ' + f.colorName; });
        var message = colorName + ' not available for: ' + parts.join(', ');
        var method = notif.info || notif.warning || notif.success;
        if (typeof method === 'function') method.call(notif, message);
    }

    // Non-colour groups that carry a business default start selected, so a product whose
    // options all have defaults is purchasable without touching the dropdowns.
    window.applyDefaultProductProperties = function(productData, suffix) {
        var ctx = context(suffix);
        var c = getComponent(ctx.selected);
        var props = productData && productData.productProperties;
        if (!c || !props || !props.length) return;
        var current = (c.data && c.data.items) ? c.data.items.slice() : [];
        var selectedGroups = {};
        current.forEach(function(it) { selectedGroups[Number(it.property_parent_id)] = true; });
        var added = [];
        for (var i = 0; i < props.length; i++) {
            var p = props[i];
            if (truthy(p.is_color_option) || !truthy(p.property_default)) continue;
            var gid = Number(p.property_parent_id);
            if (selectedGroups[gid]) continue;
            selectedGroups[gid] = true;
            added.push(makeSelection(gid, p.property_id, p.property_price));
        }
        if (added.length) rewriteSelections(c, current.concat(added));
    };

    window.applyProductColor = function(colorName, propertyIdsCsv, colorGroupIdsCsv, propertyPricesCsv, suffix) {
        var ctx = context(suffix);
        var c = getComponent(ctx.selected);
        if (!c) return;

        var nameComp = getComponent(ctx.colorName);
        if (nameComp && nameComp.data && nameComp.data.value === colorName) return;

        var propertyIds   = parseCsv(propertyIdsCsv).map(Number);
        var colorGroupIds = parseCsv(colorGroupIdsCsv).map(Number);
        var propertyPrices = parseCsv(propertyPricesCsv).map(parseFloat);

        var productData = getProductData(ctx.product);
        var allGroups = allColorGroupIds(productData);
        colorGroupIds.forEach(function(id) { allGroups[id] = true; });
        var covered = new Set(colorGroupIds);

        var current = (c.data && c.data.items) ? c.data.items : [];
        var nonColor = current.filter(function(it) { return !allGroups[Number(it.property_parent_id)]; });

        var newColor = colorGroupIds.map(function(gid, i) {
            return makeSelection(gid, propertyIds[i], propertyPrices[i]);
        });

        // Color groups this swatch doesn't cover (e.g. Black has no NUT SECONDARY entry)
        // get a fallback so add-to-cart isn't gated on a manual pick. Black gaps take
        // Silver — that's what the workshop actually mounts — else the business default.
        var fallbacks = buildGroupFallbacks(productData);
        var appliedFallbacks = [];
        Object.keys(allGroups).forEach(function(gidStr) {
            var gid = Number(gidStr);
            if (covered.has(gid)) return;
            var entry = fallbacks[gid];
            if (!entry) return;
            var fb = (colorName === 'Black' && entry.silver) ? entry.silver : entry.def;
            if (!fb) return;
            newColor.push(fb.selection);
            appliedFallbacks.push(fb);
        });

        rewriteSelections(c, nonColor.concat(newColor));
        notifyFallbacks(colorName, appliedFallbacks);

        setValue(ctx.fallbackParts, appliedFallbacks.map(function(f) { return f.parentName; }).join(', '));
        setValue(ctx.colorName, colorName);

        if (ctx.suffix === '' && typeof window.updatePickupProductCover === 'function') {
            window.updatePickupProductCover(colorName);
        }
    };
})();
